import { ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { FILL_RATE_CHART_ENDPOINT } from '../stock-chart-endpoints';

export const FILL_RATE_BY_PRODUCT_LINE_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.FILL_RATE_BY_PRODUCT_LINE,
    chartType: ChartRendererType.LINE,
    endpoint: FILL_RATE_CHART_ENDPOINT,
    filters: [],
    groupBy: ChartQueryParam.PRODUCT_ID,
    groupByMode: ChartGroupByMode.VALUE
};
